import EmptyInsights from '@static/images/empty-state/no-insights.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useScheduleDemoBanner } from '~/stores/use-schedule-demo-banner/useScheduleDemoBanner';

import * as S from './ScheduleDemoBanner.styles';

export const ScheduleDemoBanner = () => {
  const { t } = useTranslation(['stream']);
  const isVisible = useScheduleDemoBanner(state => state.isVisible);

  if (!isVisible) {
    return null;
  }

  return (
    <S.ScheduleDemoBannerRoot>
      <S.Content>
        <S.Title>{t('stream:scheduleDemo.title')}</S.Title>
        <S.Description>{t('stream:scheduleDemo.description')}</S.Description>
        <S.StyledLink
          href="https://calendar.app.google/pRJ9ZMyBF3tykQD57"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('stream:scheduleDemo.button')}
        </S.StyledLink>
      </S.Content>
      <EmptyInsights />
    </S.ScheduleDemoBannerRoot>
  );
};
